import { Check } from "lucide-react";
import { STAGES, STAGE_LABELS } from "@/lib/format";
import { cn } from "@/lib/utils";

export function ClinicalStepper({ current, done = [], orientation = "horizontal", className }) {
  const currentIdx = STAGES.indexOf(current);
  const isVertical = orientation === "vertical";

  return (
    <div
      data-testid="clinical-stepper"
      className={cn(
        isVertical ? "flex flex-col gap-0" : "flex items-center overflow-x-auto thin-scroll pb-1",
        className
      )}
    >
      {STAGES.map((stage, i) => {
        const isDone = done.includes(stage) && i < currentIdx;
        const isCurrent = stage === current;
        const state = isCurrent ? "current" : isDone ? "done" : "pending";
        return (
          <div
            key={stage}
            className={cn(
              "flex items-center",
              isVertical ? "flex-row gap-3" : "flex-col sm:flex-row shrink-0"
            )}
          >
            <div className={cn("flex items-center gap-2.5", isVertical && "py-1")}>
              <div
                className={cn(
                  "flex h-8 w-8 shrink-0 items-center justify-center rounded-full border-2 text-xs font-bold transition-colors",
                  state === "done" && "border-[#00A85A] bg-[#00A85A] text-white",
                  state === "current" && "border-[#00A85A] bg-[#E8F7F0] text-[#008F4D] dark:bg-[#00A85A]/15 dark:text-[#3FD98A] ring-4 ring-[#00A85A]/15",
                  state === "pending" && "border-[#E2E8F0] dark:border-[#223139] bg-transparent text-[#8B9698]"
                )}
              >
                {state === "done" ? <Check className="h-4 w-4" /> : i + 1}
              </div>
              <span
                className={cn(
                  "whitespace-nowrap text-xs font-semibold",
                  state === "current" ? "text-[#101516] dark:text-white" : "text-[#8B9698]"
                )}
              >
                {STAGE_LABELS[stage]}
              </span>
            </div>
            {i < STAGES.length - 1 && (
              <div
                className={cn(
                  isVertical
                    ? "ml-4 h-5 w-0.5 my-0.5"
                    : "mx-2 hidden sm:block h-0.5 w-6 lg:w-10",
                  i < currentIdx ? "bg-[#00A85A]" : "bg-[#E2E8F0] dark:bg-[#223139]"
                )}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
